import React, { createContext, useState, useEffect, useCallback } from "react";

import { useLocation } from "react-router-dom";

import { getDashboard } from "apps/education-platform/features/dashboard/api/dashboard.api";

import { getOrganizationMenu } from "apps/education-platform/features/dashboard/api/organization.api";

const initialState = {
  dashboard_data: [],

  organizationmenu_data: [],

  branch_symbol: "",

  itemName: "Dashboard",

  isLoadedDashboard: false,

  isLoadedOrganizationMenu: false,

  apiReady: false,

  error: null,
};

export const EducationContext = createContext({
  state: initialState,
  setContext: () => {},
});

const ORGANIZATION_LEVEL_ROUTES = new Set([
  "dashboard",
  "files",
]);

export const EducationProvider = ({ children }) => {
  const location = useLocation();

  const [state, setState] = useState(initialState);

  const setContext = (updates) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const initializeEducation = useCallback(async () => {
    const parts = location.pathname
      .split("/")
      .filter(Boolean);

    const firstSegment = parts[0] || "";
    const secondSegment = parts[1] || "";

    const isGlobalFilesRoute =
      firstSegment === "files";

    const organization = isGlobalFilesRoute
      ? process.env.REACT_APP_ORGANIZATION_SYMBOL
      : firstSegment;

    const branch = isGlobalFilesRoute
      ? ""
      : ORGANIZATION_LEVEL_ROUTES.has(secondSegment)
        ? ""
        : secondSegment;

    if (!organization) {
      return;
    }

    try {
      const dashboard = await getDashboard({
        apiUrl: process.env.REACT_APP_API_URL,
        organizationSymbol: organization,
        branchSymbol: branch,
      });

      const menu = await getOrganizationMenu({
        apiUrl: process.env.REACT_APP_API_URL,
        organizationSymbol: organization,
      });

      setState((prev) => ({
        ...prev,
        dashboard_data: dashboard,
        organizationmenu_data: menu,
        branch_symbol: branch,
        isLoadedDashboard: true,
        isLoadedOrganizationMenu: true,
        apiReady: true,
        error: null,
      }));
    } catch (err) {
      console.error("EducationContext error", err);

      setState((prev) => ({
        ...prev,
        isLoadedDashboard: false,
        isLoadedOrganizationMenu: false,
        apiReady: false,
        error: err,
      }));
    }
  }, [location.pathname]);

  useEffect(() => {
    initializeEducation();
  }, [initializeEducation]);

  return (
    <EducationContext.Provider
      value={{
        state,
        setContext,
      }}
    >
      {children}
    </EducationContext.Provider>
  );
};
